<template>
  <div :class="$attrs.class">
    <label v-if="label" class="form-label" :for="id">{{ label }} <span v-if="required">*</span> :</label>
    <QuillEditor content-type="html"
                 v-model:content="modelValue"
                 theme="snow"
                 style="height: 200px"
                 :toolbar="toolbar"
                 @update:content="$emit('update:modelValue', modelValue)"
    />
    <hint :hint="hint"></hint>
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'
import Hint from '@/Shared/Hint'
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'

export default {
  inheritAttrs: false,
  components: {Hint, QuillEditor},
  data(){
    return {
      toolbar: [
        [{ size: ['small', false, 'large', 'huge'] }],
        ['bold', 'italic', 'underline'],
        [{ color: [] }, { background: [] }],
        [{ list: 'ordered' }, { list: 'bullet' }],
      ]
    }
  },
  props: {
    id: {
      type: String,
      default() {
        return `text-input-${uuid()}`
      },
    },
    type: {
      type: String,
      default: 'text',
    },
    error: String,
    label: String,
    modelValue: String,
    hint: String,
    required: Boolean
  },
  emits: ['update:modelValue'],
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
    setSelectionRange(start, end) {
      this.$refs.input.setSelectionRange(start, end)
    },
  },
}
</script>
<style scoped>
:deep(.ql-toolbar){
  border-radius: 5px 5px 0px 0px!important;
  border-color: #e2e8f0;
}
:deep(.ql-container){
  border-radius: 0px 0px 5px 5px!important;
  border-color: #e2e8f0;
}
input::placeholder{
  color:#adadad;
  font-size: 14px;
}
</style>
